export const PAGES = {
  AGREEMENT: 'agreement',
  CONTACT: 'contact',
  PASSWORD: 'password',
};

export default PAGES;
